import { NcwOnboardingSlideTeams } from '@capsicum/common';
import { useOnboardingSlidesTranslations } from '@capsicum/features/nc-onboarding/web';
import { type FC } from 'react';

import * as S from './components.styled';
import { Shell } from './Shell';

export const SecondPoblanoPage: FC<{ goBack: () => void; next: () => void }> = ({ goBack, next }) => {
	const $t = useOnboardingSlidesTranslations();

	return (
		<Shell goBack={goBack} proceed={next}>
			<S.ImageWrapper>
				<S.Image
					alt="secondNCW-slide-image"
					data-testid="onboarding-second-slide-image"
					src={NcwOnboardingSlideTeams}
				/>
			</S.ImageWrapper>
			<S.HeadlineText>{$t('onboarding.ncw.one.title')}</S.HeadlineText>
			<S.Dropline>{$t('onboarding.ncw.one.description')}</S.Dropline>
		</Shell>
	);
};
